<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/><meta content="text/html; charset=UTF-8"/><title>THE CANOPY</title><link href="default.css" rel="stylesheet" type="text/css"/><link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe.page-template+xml"/>
<p class="tx2" id="page5">Do not be afraid of the terrors of the night,</p>
<p class="tx3" id="p0005-02-1">nor fear the dangers of the day,</p>
<p class="tx2" id="p0005-P-1">nor dread the plague that stalks in darkness . . .</p>
<p class="tx2" id="p0005-P-2">If you make the L<span class="small">ORD</span> your refuge,</p>
<p class="tx3" id="p0005-P-3">if you make the Most High your shelter,</p>
<p class="tx2" id="p0005-P-4">no evil will conquer you;</p>
<p class="tx3" id="p0005-P-5">no plague will come near your dwelling . . . <br/><br/></p>
<p class="tx2" id="p0005-P-7">He will not let you stumble and fall;</p>
<p class="tx3" id="p0005-P-8">the one who watches over you will not sleep. <br/><br/></p>
<p class="txr" id="p0005-03-2">—P<span class="small">SALMS 91:5–6, 9–10; 121:3</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?8a143202